import React, { useState } from 'react';
import { SearchIcon, FilterIcon } from 'lucide-react';
import { ListingCard } from '../components/ListingCard';
import { allServices } from '../data/mockData';
export function ServicesPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('newest');
  const filteredServices = allServices.filter(item => item.title.toLowerCase().includes(searchTerm.toLowerCase()) || item.description.toLowerCase().includes(searchTerm.toLowerCase())).sort((a, b) => {
    if (sortBy === 'views') return b.views - a.views;
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
  });
  return <main className="min-h-screen bg-gray-50" data-id="element-590">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-orange-600 to-orange-500 text-white py-16 px-4" data-id="element-591">
        <div className="max-w-4xl mx-auto text-center" data-id="element-592">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-593">
            Explore Services
          </h1>
          <p className="text-xl text-orange-100" data-id="element-594">
            Find professional services from skilled creatives in Nakuru
          </p>
        </div>
      </section>

      <section className="py-8 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-595">
        {/* Search and Filter */}
        <div className="bg-white rounded-xl shadow-md p-4 mb-8" data-id="element-596">
          <div className="flex flex-col md:flex-row gap-4" data-id="element-597">
            <div className="flex-1 relative" data-id="element-598">
              <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" data-id="element-599" />
              <input type="text" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} placeholder="Search services..." className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent" data-id="element-600" />
            </div>
            <div className="flex items-center space-x-2" data-id="element-601">
              <FilterIcon className="text-gray-400 w-5 h-5" data-id="element-602" />
              <select value={sortBy} onChange={e => setSortBy(e.target.value)} className="px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent" data-id="element-603">
                <option value="newest" data-id="element-604">Newest First</option>
                <option value="views" data-id="element-605">Most Viewed</option>
              </select>
            </div>
          </div>
        </div>

        {/* Results Count */}
        <p className="text-gray-600 mb-6" data-id="element-606">
          Showing {filteredServices.length}{' '}
          {filteredServices.length === 1 ? 'service' : 'services'}
        </p>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-607">
          {filteredServices.map(item => <ListingCard key={item.id} listing={item} data-id="element-608" />)}
        </div>

        {filteredServices.length === 0 && <div className="text-center py-12" data-id="element-609">
            <p className="text-gray-500 text-lg" data-id="element-610">
              No services found matching your search.
            </p>
          </div>}
      </section>
    </main>;
}